<template>
  <div class="auth">
    <div class="auth__image">
      <a href="https://www.solency.com/" class="auth__image__logo">
        <img src="@/assets/svg/logo-sovalis-white.svg" alt="" />
      </a>
      <h1 class="title title--white auth__image__title">
        La plateforme <br />
        qui accompagne <br />
        les avocats dans leur
        <span class="title title__highlight">digitalisation</span>.
      </h1>
      <p class="text text--white">
        Copyright {{ currentYear }}© Sovalis -
        <a
          class="text--white link--no-decoration"
          href="https://sovalis.kerialis.fr/contact/"
          target="_blank"
          >Contact</a
        >
        <br />
        <a
          class="text--white link--no-decoration"
          href="https://sovalis.kerialis.fr/politique-des-cookies/"
          target="_blank"
          >Politique des cookies</a
        >
        -
        <a
          class="text--white link--no-decoration"
          href="https://sovalis.kerialis.fr/mentions-legales/"
          target="_blank"
          >Mentions légales</a
        >
        <br />
        <a
          class="text--white link--no-decoration"
          href="https://kerialis.fr/protection-des-donnees-a-caractere-personnel"
          target="_blank"
          >Protection des données</a
        >
      </p>
    </div>
    <div class="auth__form">
      <div class="auth__form__nav">
        <div class="auth__form__nav__links">
          <!--
        <div class="auth__form__nav__link__border">
          <router-link
            :class="[
              'auth__form__nav__link',
              { 'auth__form__nav__link--active': noAccountLinkActive },
            ]"
            :to="{ name: 'Register' }"
          >
            Je n'ai pas de compte
          </router-link>
          </div>
          <router-link
            :class="[
              'auth__form__nav__link',
              { 'auth__form__nav__link--active': accountLinkActive },
            ]"
            :to="{ name: 'Connection' }"
          >
            J'ai un compte
          </router-link>
                    -->
        </div>
      </div>
      <div class="auth__form__content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      apiURL: process.env.VUE_APP_API_URL,
      currentYear: new Date().getFullYear(),
    };
  },
  computed: {
    accountLinkActive() {
      const routes = [
        'Connection',
        'ResetPassword',
        'ForgotPassword',
        'EmailCheckIn',
        'NewEmailCheckIn',
      ];

      return routes.includes(this.$route.name);
    },
    noAccountLinkActive() {
      const routes = ['Register', 'VerifyEmail'];

      return routes.includes(this.$route.name);
    },
  },
};
</script>
